import { c as _c } from "react/compiler-runtime";
import { useRange } from "@website/ui/range/range.hook";
import styles from "@website/ui/range/range.module.scss";
import { RangePropertiesType } from "@website/ui/range/range.types";
import { FC } from "react";
export const Range: FC<RangePropertiesType> = properties => {
  const $ = _c(22);
  const {
    startText,
    endText,
    color
  } = properties;
  const {
    stepItems,
    minInputProperties,
    maxInputProperties,
    rangeProperties,
    isSingle
  } = useRange(properties);
  let t0;
  if ($[0] !== endText || $[1] !== startText) {
    t0 = startText || endText ? <div className={styles.text}><span>{startText}</span><span>{endText}</span></div> : "";
    $[0] = endText;
    $[1] = startText;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const t1 = `${styles["range-wrapper"]} ${styles[color || "primary"]}`;
  let t2;
  if ($[3] !== isSingle || $[4] !== minInputProperties) {
    t2 = !isSingle && <input className={`${styles.input} ${styles.first}`} aria-label="Minimum value" {...minInputProperties} />;
    $[3] = isSingle;
    $[4] = minInputProperties;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== maxInputProperties) {
    t3 = <input className={`${styles.input} ${styles.second}`} aria-label="Maximum value" {...maxInputProperties} />;
    $[6] = maxInputProperties;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== stepItems) {
    t4 = stepItems.length > 0 && <div className={styles["steps-wrapper"]}>{stepItems.map(_temp)}</div>;
    $[8] = stepItems;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className={styles.track} />;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== rangeProperties) {
    t6 = <div className={styles.range} {...rangeProperties} />;
    $[11] = rangeProperties;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t1 || $[14] !== t2 || $[15] !== t3 || $[16] !== t4 || $[17] !== t6) {
    t7 = <div className={t1}>{t2}{t3}{t4}{t5}{t6}</div>;
    $[13] = t1;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t0 || $[20] !== t7) {
    t8 = <div>{t0}{t7}</div>;
    $[19] = t0;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
};
function _temp(t0) {
  const {
    out,
    id
  } = t0;
  return <div className={`${styles.step} ${out ? styles.out : ""}`} key={id} />;
}